module.exports = __webpack_public_path__ + "static/media/rain.d9f60753.png";